<template>
    <div class="menus">
        <template v-for="menu in routes">
            <div
                v-show="!menu.hidden"
                class="menu-item"
                :class="{ active: menu.path && selectedPath.indexOf(menu.path) === 0, disabled: !menu.path }"
                :key="menu.path"
                @click.stop="routeTo(menu)"
            >
                {{ menu.name }}
                <div class="second-menu" v-if="menu.children && menu.children.length>0">
                    <template v-for="subMenu in menu.children">
                        <div
                            v-show="!subMenu.hidden"
                            class="second-menu-item"
                            :class="{ active: subMenu.path && selectedPath === subMenu.path, disabled: !subMenu.path }"
                            :key="subMenu.path"
                            @click.stop="routeTo(subMenu)"
                        >
                            {{ subMenu.name }}
                        </div>
                    </template>
                </div>
                <div class="second-menu" v-if="menu.path === '/software'" style="padding: 40rem;">
                    <div class="software-col">
                        <div class="software-col-title">
                            面向
                            <div class="software-col-title-span">打印机用户</div>
                        </div>
                        <div class="software-col-list">
                            <div class="software-col-item" @click="openNew('https://gj.fanqie365.cn')">
                                <img src="../../views/software/images/gj.png" alt="icon">
                                番茄打印管家
                            </div>
                            <div class="software-col-item" @click="openNew('https://fanqie365.cn')">
                                <img src="../../views/software/images/bq.png" alt="icon">
                                番茄标签
                            </div>
                            <div class="software-col-item" @click="openNew('https://v.kuaimai.com')">
                                <img src="../../views/software/images/v.png" alt="icon">
                                番茄视频管家
                            </div>
                        </div>
                    </div>
                    <div class="software-split"></div>
                    <div class="software-col">
                        <div class="software-col-title">
                            面向
                            <div class="software-col-title-span other-color">软件开发者</div>
                        </div>
                        <div class="software-col-list">
                            <div class="software-col-item" @click="openNew('https://solution.kuaimai.com/')">
                                <img src="../../views/software/images/jjfa.png" alt="icon">
                                番茄打印解决方案
                            </div>
                            <div class="software-col-item" @click="openNew('https://cloudprint.kuaimai.com/')">
                                <img src="../../views/software/images/ydy.png" alt="icon">
                                云打印
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import {routes} from "../../router";

export default {
    name: "Menus",
    data() {
        return {
            routes: routes,
            selectedPath: "",
        };
    },
    mounted() {
        this.selectedPath = this.$route.path;
        this.$router.afterEach((to) => {
            this.selectedPath = to.path;
        });
    },
    methods: {
        routeTo(menu) {
            if (menu.isLink) {
                this.openNew(menu.path);
                return;
            }
            let route = menu.path;
            if (!route || route === this.selectedPath || (menu.redirect && menu.redirect === this.selectedPath)) {
                return;
            }
            this.$router.push(route);
        },
    },
};
</script>

<style lang="scss" scoped>
.menus {
    display: flex;
    flex-direction: row;

    .menu-item {
        position: relative;
        padding: 6rem 14rem;
        font-size: 18rem;
        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        cursor: pointer;
        transition: all 0.3s;

        &.active {
            color: #FD6520;
            transition: all 0.3s;
            background: #fff;
            border-radius: 50rem;
        }

        &.disabled {
            cursor: not-allowed;
            color: #cccccc;
        }

        &:hover {
            color: #FD6520;
            transition: all 0.3s;
            background: #fff;
            border-radius: 50rem;

            .second-menu {
                display: flex;
            }
        }

        &:not(:last-child) {
            margin-right: 32rem;
        }

        .second-menu {
            position: absolute;
            top: 48rem;
            right: -110%;
            background: #fff;
            border-radius: 20rem;
            padding: 0 40rem;
            display: none;
            flex-direction: row;
            align-items: center;
            gap: 40rem;

            &::before {
                content: '';
                position: absolute;
                top: -20rem;
                left: 0;
                width: 100%;
                height: 20rem;
                background: rgba(122, 0, 112, 0);
            }

            .second-menu-item {
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                font-size: 14rem;
                color: #333333;
                padding: 20rem 0;
                line-height: 20rem;
                text-shadow: 0 2rem 40rem rgba(0, 0, 0, 0.1);
                white-space: nowrap;
                transition: all .3s;

                &:hover {
                    color: #FD6520;
                }

                &.active {
                    color: #FD6520;
                    transition: all 0.3s;
                }
            }

            .software-col {
                text-wrap: nowrap;

                .software-col-title {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 9rem;

                    .software-col-title-span {
                        padding: 2rem 10rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 500;
                        font-size: 18rem;
                        color: #FD6520;
                        text-shadow: 0 2rem 40rem rgba(0, 0, 0, 0.1);
                        background: rgba(253, 101, 32, 0.1);
                        box-shadow: 0 2rem 40rem 0 rgba(0, 0, 0, 0.1);
                        border-radius: 4rem;
                        line-height: 25rem;

                        &.other-color {
                            color: #407AFA;
                            background: rgba(66, 124, 251, 0.1);
                            box-shadow: 0 2rem 40rem 0 rgba(0, 0, 0, 0.1);
                        }
                    }
                }

                .software-col-list {
                    margin-top: 23rem;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 28rem;

                    .software-col-item {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        gap: 11rem;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        font-size: 14rem;
                        color: #333333;
                        line-height: 20rem;
                        text-shadow: 0 2rem 40rem rgba(0, 0, 0, 0.1);

                        &:hover {
                            color: #FD6520;

                            img {
                                transform: scale(1.1);
                            }
                        }

                        img {
                            width: 48rem;
                            height: 48rem;
                        }
                    }
                }
            }

            .software-split {
                width: 1rem;
                height: 131rem;
                background: rgba(0, 0, 0, 0.1);
            }
        }
    }
}
</style>
